import AttachmentsReadOnly from './AttachmentsReadOnly';
import { AttachmentsSlotRoot } from './styles';
import type { ApprovalViewAttachment } from './types';

/** 첨부 영역 — 표시 가능한 첨부 0건이면 AttachmentsReadOnly 가 null 을 반환해 빈 영역만 차지. */

type AttachmentsSlotProps = {
  attachments: ApprovalViewAttachment[];
};

const AttachmentsSlot = ({ attachments }: AttachmentsSlotProps) => (
  <AttachmentsSlotRoot>
    <AttachmentsReadOnly attachments={attachments} />
  </AttachmentsSlotRoot>
);

export default AttachmentsSlot;
